import React from 'react';
import CustomIcon, { IconType } from '../../../../shared/custom-icon/custom-icon';

interface PolicyActionToastProps {
    title: string;
    description: string;
    onClose: () => void;
}

const PolicyActionToast: React.FC<PolicyActionToastProps> = ({ title, description, onClose }) => (
    <div className="policy-action-toast">
        <div className="toast-header">
            <div className="toast-title">{title}</div>
            <button type="button" className="close-btn" onClick={onClose}>
                <CustomIcon type={IconType.X} size={9} />
            </button>
        </div>
        <div className="toast-desc">{description}</div>
    </div>
);

export default PolicyActionToast;